import styled from 'styled-components'
import { respondTo } from '../../../../styles/_respondTo'

export const DivSkillsTitle = styled.div`
  padding: 10px;
  border-bottom: 1px dashed rgb(92, 96, 105);

  ${respondTo.lg`
  `}

  ${respondTo.xl`
  `}
`
export const DivImages = styled.div`
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -moz-flex;
  display: -webkit-flex;
  display: flex;
  -webkit-flex-wrap: wrap;
  flex-wrap: wrap;
  margin-bottom: 20px;
  
`

export const ChildGridContainer = styled.div`

  ${respondTo.xs`

  `}

  ${respondTo.sm`
  `}

  ${respondTo.md`
  `}

  ${respondTo.lg`
  grid-row: ${props => props.gridRow || 'auto'};
  grid-column: ${props => props.gridColumn || 'auto'};
  `}

  ${respondTo.xl`
  grid-row: ${props => props.gridRow || 'auto'};
    `}

`